import Skeleton from '@mui/material/Skeleton';
import { type CSSProperties, useSyncExternalStore } from 'react';
import { createPortal } from 'react-dom';
import { fadeIn } from '~/app.css';

export const SkeletonMacro = ({
  containerRef,
  style,
  query,
}: {
  containerRef?: React.RefObject<HTMLElement | null>;
  style?: CSSProperties;
  query: string;
}) => {
  const subscribe = (callback: () => void) => {
    const container = containerRef?.current;
    if (!container) return () => {};
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element && (node.matches(query) || node.querySelector(query))) {
            callback();
            return;
          }
        }
      }
    });
    observer.observe(container, { childList: true, subtree: true });
    return () => observer.disconnect();
  };

  const getSnapshot = () => document.querySelectorAll(query).length;

  const nodeCount = useSyncExternalStore(subscribe, getSnapshot, () => 0);

  if (nodeCount === 0) return null;

  const nodes = Array.from(document.querySelectorAll(query));

  return nodes.map((node, index) =>
    createPortal(
      <div className={fadeIn}>
        <Skeleton
          style={{ position: 'absolute', left: 0, top: 0, ...style }}
          variant="rectangular"
          width="100%"
          height="100%"
        />
      </div>,
      node,
      `skeleton-${index}`
    )
  );
};
